// extracted by mini-css-extract-plugin
export default {"jarvis":"part3_jarvis__ZL5cm"};